<template>
    <div class="condition-content">
        <compare-selector
            :value="logicValue"
            type="EDUCATION_LOGIC"
            placeholder=""
            :multiple="false"
            @change="onLogicChange"
        />
        <compare-selector
            ref="selector"
            :value="educationValue"
            :multiple="true"
            :valid="valid"
            type="EDUCATION"
            :placeholder="$t('请选择学历')"
            @change="onValueChange"
        />
    </div>
</template>

<script>
import CompareSelector from './plugins/compare-selector';

export default {
  name: 'Education',

  components: {
    CompareSelector,
  },

  props: {
    optionInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Object,
      default() {
        return {
          logicValue: '==',
          educationValue: [],
        };
      },
    },
  },
  data() {
    const { logicValue, educationValue } = this.value;
    return {
      logicValue,
      educationValue,
      valid: true,
    };
  },
  computed: {
    brief() {
      if (this.educationValue && this.educationValue.length > 0) {
        let logicText = '';
        switch (this.logicValue) {
        case '!=':
          logicText = this.$t('不是');
          break;
        case '==':
          logicText = this.$t('是');
          break;
        default:
          break;
        }
        const selectText = this.getBriefText('selector', this.educationValue);
        return `${this.optionInfo.text}${logicText}${selectText}`;
      }
      return '';
    },
  },

  watch: {
    value(newValue) {
      this.logicValue = newValue.logicValue || '==';
      this.educationValue = newValue.educationValue || [];
    },
  },

  mounted() {
    this.onChange(this.currentValue);
  },

  methods: {
    validate() {
      this.valid = !!(this.educationValue && this.educationValue.length > 0);
      return this.valid;
    },
    onLogicChange(value) {
      this.logicValue = value;
      this.onChange();
    },
    onValueChange(value) {
      this.valid = true;
      this.educationValue = value;
      this.onChange();
    },
    onChange() {
      const ruleData = {
        name: 'education',
        type: 'array',
        operation: this.logicValue === '==' ? 'arrayInclude' : '!arrayInclude',
        value: JSON.stringify(this.educationValue),
      };
      const showVal = {
        logicValue: this.logicValue,
        educationValue: this.educationValue,
      };
      this.$emit('change', {
        ruleData,
        showVal,
        brief: this.brief,
        validation: !!(this.educationValue && this.educationValue.length > 0),
      });
    },
    getBriefText(ref, selectedValue) {
      return selectedValue
        ? this.$refs[ref].currentOptions
          .filter(obj => selectedValue.indexOf(obj.value) > -1)
          .map(item => item.text)
          .join(',')
        : '';
    },
  },
};
</script>
